import { useMemo } from "react";
import {
  useGetDomoReportsQuery,
  useGetDomoReportByIdQuery,
  useCreateDomoReportMutation,
  useUpdateDomoReportMutation,
  useDeleteDomoReportMutation,
  useGetBasicCompanyDetailsQuery,
  useGetRolesQuery,
} from "utils/api/baseSlice";
import { getCompanyId } from "services/identity.service";

export const  deleteDomoReport = () => {
  const [deleteDomoReport, result] = useDeleteDomoReportMutation();
  
  const mutateAsync = async (id) => {
    const response = await deleteDomoReport({ params: { id } });
    return response.data || response.error || response;
  };

  return { mutateAsync, ...result };
};

export const addDomoReport = () => {
  const [createDomoReport, result] = useCreateDomoReportMutation();
  
  const mutateAsync = async ({ description, title, reportUrl, roleIds, companyIds, embedId }) => {
    const response = await createDomoReport({
      params: {},
      body: { description, title, reportUrl, roleIds, companyIds, embedId },
    });
    return response.data || response.error || response;
  };

  return { mutateAsync, ...result };
};

export const editDomoReport= () => {
  const [updateDomoReport, result] = useUpdateDomoReportMutation();
  
  const mutateAsync = async ({ description, title, reportUrl, roleIds, companyIds, embedId, id }) => {
    const response = await updateDomoReport({
      params: { id },
      body: { description, title, reportUrl, roleIds, companyIds, embedId },
    });
    return response.data || response.error || response;
  };

  return { mutateAsync, ...result };
};

export const useRoleQuery = () => {
  const { data, ...rest } = useGetRolesQuery({ allRoles: true });
  
  const memoizedData = useMemo(() => {
    return data || [];
  }, [data]);
  
  return {
    data: memoizedData,
    ...rest,
  };
};

export const useCompanyQuery = () => {
  const { data, ...rest } = useGetBasicCompanyDetailsQuery({});
  
  const memoizedData = useMemo(() => {
    // commonTransform returns res.entity || res, so data might be the array directly or { entity: [...] }
    const companiesArray = Array.isArray(data) ? data : data?.entity;
    console.log('[useCompanyQuery] Raw data:', data);
    console.log('[useCompanyQuery] Companies array:', companiesArray);
    const result = companiesArray?.map((company) => ({
      value: company?.id,
      label: company?.companyName,
    })) || [];
    console.log('[useCompanyQuery] Transformed result:', result);
    return result;
  }, [data]);
  
  return {
    data: memoizedData,
    ...rest,
  };
};

export const useDomoReportQuery = ({ search = '', offset = 0, limit = 15 } = {}) => {
  const companyId = getCompanyId();
  const { data, ...rest } = useGetDomoReportsQuery({
    companyId,
    search,
    offset,
    limit,
  });

  return { data, ...rest };
};

export const useDomoReportByIdQuery = (id) => {
  const companyId = getCompanyId();
  const { data, ...rest } = useGetDomoReportByIdQuery(
    { companyId, id },
    { skip: !id }
  );

  return { data, ...rest };
};
